import { createI18n } from 'petite-vue-i18n'
import { resolveValue } from '@intlify/core-base'
import en from '../locales/en.json'
import { SUPPORTED_LOCALES } from '../utils/supportedLocales.js'

// Re-exported so existing consumers can keep importing it from '../i18n'. The
// canonical definition lives in utils/ (embed-safe — see that file).
export { SUPPORTED_LOCALES }

// petite-vue-i18n (runtime-only, composition API): one global catalog. English
// ships in the entry; other locales lazy-load so English users pay ~0 extra
// bytes. Message JSON is precompiled by @intlify/unplugin-vue-i18n (vite).
export const i18n = createI18n({
  legacy: false,
  globalInjection: true, // $t available in every template
  locale: 'en',
  fallbackLocale: 'en', // partial de catalogs render English — phased extraction stays safe
  // petite-vue-i18n registers NO message resolver, so core-base defaults to
  // flat key-value lookup ('app.nav.bookmarks' as a literal top-level key) and
  // silently key-passes-through on nested catalogs. resolveValue is the full
  // nested resolver — without it every t() renders the raw key.
  messageResolver: resolveValue,
  messages: { en }
})

// Explicit map (not a template-literal import) so Vite creates exactly one
// lazy chunk per extra locale and never re-bundles en.json.
const loaders = {
  de: () => import('../locales/de.json'),
  fr: () => import('../locales/fr.json'),
  es: () => import('../locales/es.json'),
  pt: () => import('../locales/pt.json'),
  it: () => import('../locales/it.json')
}
const loaded = new Set(['en'])

export async function setI18nLocale(locale) {
  if (!loaded.has(locale) && loaders[locale]) {
    const messages = await loaders[locale]()
    i18n.global.setLocaleMessage(locale, messages.default)
    loaded.add(locale)
  }
  i18n.global.locale.value = locale // composition mode: locale is a ref → live re-render
}
